import { APP_MENU } from "../consts/appMenu.consts"
import { DEFAULT_ROUTES } from "../routers/roleRoutes/defaultRoutes.routes"
import { APP_FILTERS_MENU_ROUTES } from "../routers/routes/appFiltersMenuRoutes.router"
import { getRoutesByRole } from "./routes.utils"

function _getApplicationPathsByRole(role) {
  const routes = getRoutesByRole(role)
  const defaultPaths = DEFAULT_ROUTES.map(({ path }) => path)
  return routes.map(({ path }) => path).concat(defaultPaths)
}

function _filterModules(menu = [], paths = []) {
  const newMenu = menu.filter((item) => {
    if (item.modules) {
      return _filterModules(item.modules, paths).length > 0
    }
    return paths.includes(item.path)
  })

  return newMenu
}

/**
 *
 * @param {string[]} paths
 * @returns {(item) => boolean}
 */
const allowedMenu =
  (paths) =>
  ({ modules, path, overlay }) => {
    if (modules) {
      return modules.length > 0
    }

    return paths.includes(path) || Boolean(overlay)
  }

/**
 * Returns the app menu based on the user's role
 * @param {string} role
 * @returns {import("../types/appMenu").RenderableAppMenuItem[]}
 */
export function getAppMenuByRole(role) {
  const paths = _getApplicationPathsByRole(role)
  return APP_MENU.filter((item) => item.roles?.includes(role) || !item.roles)
    .map((item) => {
      const { name, icon, iconClass } = item

      if (item.modules) {
        return {
          name,
          icon,
          iconClass,
          modules: _filterModules(item.modules, paths),
        }
      }

      if (item.path) {
        return {
          name,
          icon,
          iconClass,
          path: item.path,
        }
      }

      if (item.overlay) {
        return {
          name,
          icon,
          iconClass,
          overlay: item.overlay,
        }
      }

      return null
    })
    .filter(Boolean)
    .filter(allowedMenu(paths))
}

export const defineRoute = (path) => {
  const pathSplited = path.split("/")
  const fistPart = pathSplited[1]
  const secondPart = pathSplited[2]

  const firstPath = `/${fistPart}`
  const secondPath = secondPart ? `/${fistPart}/${secondPart}` : `/${fistPart}`
  const checkFirstPath = Boolean(APP_FILTERS_MENU_ROUTES[firstPath])
  const checkSecondPath = Boolean(APP_FILTERS_MENU_ROUTES[secondPath])
  const check = checkSecondPath || checkFirstPath
  let pathToUse = null
  if (checkFirstPath) {
    pathToUse = firstPath
  } else if (checkSecondPath) {
    pathToUse = secondPath
  }
  return { pathToUse, check }
}
